/**
 * Direct edit of non-synced object fields (UserName, Upn, Email) via `updateobjectfield` — no override.
 *
 * Translation keys (register in backend / CMS):
 * - object.sourcedata.directfield.edit.warning
 */
import * as ko from "knockout";
import {IMessageData, IObjectData, ISyncField} from '../../../index';
import PromiseRequest from "../../../req/PromiseRequest";
import {SPINNER} from "../../../constants";
import {createErrorMessage, getObjectDefinition, getSyncFieldValue, IObjectDefinition} from "../../../util/misc";
import pubsub from "../../../pubsub";
import {global} from "../../../appContext";
import {IDialogOptions} from "../../dialog/index";
import {ButtonManager} from "../../../util/ButtonManager";
import {getCancelButton, getContinueButton} from "../../../constants/RouteDefinitions";
import objectfield_editHtml from './objectfield.edit.html?raw';

export let template = objectfield_editHtml;

interface IParams {
    object: IObjectData
    syncfield: ISyncField
    dialog: IDialogOptions
}

export class viewModel {
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private isReady: KnockoutObservable<boolean> = ko.observable(true);
    private reqUpdateField: PromiseRequest = new PromiseRequest('updateobjectfield');
    private syncfield: ISyncField;
    private value: KnockoutObservable<string>;
    private objDef: IObjectDefinition;
    private objName: string;
    private readonly pageButtons: ButtonManager = new ButtonManager()

    constructor(private params: IParams) {
        this.syncfield = params.syncfield;
        this.value = ko.observable(this.syncfield.value ?? '');
        this.objDef = getObjectDefinition(params.object.type.id)!;
        this.objName = getSyncFieldValue(this.objDef.syncfieldDisplayName ?? [], params.object.syncfields) ?? '';

        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.(), {
            validator: () => this.isReady(),
        }))
        this.pageButtons.add(getContinueButton({
            label: 'update value',
            onClick: () => this.onUpdateClick(),
            enabled: () => this.value().trim() !== (this.syncfield.value ?? ''),
            validator: () => this.isReady(),
        }))
    }

    private onUpdateClick() {
        this.isReady(false);
        this.messageData({message: `((updating|td)) ${SPINNER}`});
        this.params.dialog.isClosable?.(false);
        this.reqUpdateField
            .request({
                objectid: this.params.object.id,
                fieldname: this.syncfield.name,
                value: this.value().trim(),
            })
            .then(() => {
                global.cacheManager.removeCache('searchobject');
                global.cacheManager.removeCache('getobject');
                pubsub.trigger('object.needs.refresh');
                global.snackbarData({message: 'update completed'})
                this.params.dialog.isClosable?.(true);
                this.params.dialog.doClose?.();
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
                this.isReady(true);
                this.params.dialog.isClosable?.(true);
            });
    }

    dispose() {
        this.reqUpdateField.abort();
    }
}
